import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OfflineRequestService {

  routes: any = {
    get: {},
    post: {},
    put: {},
    delete: {}
  };

  constructor() {
  }

  request(req:any){
    
  }

  get(route: string, query: { limit?: number, offset?: number, sort?: string } = {}, id: string | null = null): { [key: string]: any } {
    try {
      let res: any[] = JSON.parse(localStorage.getItem(route) || '[]');
  
      if (!res.length) return { [route]: [] };
  
      if (query.offset) {
        res = res.slice(query.offset);
      }
  
      if (query.limit) {
        res = res.slice(0, query.limit);
      }
  
      if (id) {
        res = res.find((item) => item.id === id) || null;
      }
  
      return { [route]: res };
      
    } catch (error) {
      console.error('Error fetching data:', error);
      return { [route]: [] };
    }
  }
  

  documents(){

  }
}
